import { render, staticRenderFns } from "./temp_youtube.vue?vue&type=template&id=e154a250&"
import script from "./temp_youtube.vue?vue&type=script&lang=js&"
export * from "./temp_youtube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports